import React from 'react';
import '../../Styles/OverviewCards.css'

const OverviewCards = ({ omsætningIalt, resultatIalt }) => {
    const options = { style: 'currency', currency: 'DKK'};
    
    return (
<div className="overview-container">
            <h3 className="sub-header">Overblik</h3>
            <div className="overview-row">
                <div className="overview-col">
                    <div className="overview-card">
                        <h5 className="card-title">Omsætning</h5>
                        <div className="card-content">{ omsætningIalt !== undefined ? 
                                Intl.NumberFormat('dk-DK', options).format(Math.abs(omsætningIalt)): 
                                'N/A'}
                        </div>
                    </div>
                </div>
                <div className="overview-col">
                    <div className="overview-card">
                        <h5 className="card-title">Resultat</h5>
                        <div className="card-content">{ resultatIalt !== undefined ? 
                                Intl.NumberFormat('dk-DK', options).format(-resultatIalt) : 
                                'N/A'}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OverviewCards;
